import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../Header/Header";
import EProductspage from "../../ExtraProductpage/EProductspage";
import Formpage from "../../Form/Form";
import Footer from "../../Footer/Footer";
import icon1 from "../../assets/Facesense_LandingPage_Img/CheckIcon.svg";
import icon3 from "../../assets/Facesense_LandingPage_Img/DownloadIcon.svg";
import icon4 from "../../assets/Facesense_LandingPage_Img/Cancel.svg";
import icon5 from "../../assets/Facesense_LandingPage_Img/SendIcon.svg";
import image from "../../assets/image/video_ana_Safety_Gear_Violation.jpg";
import request from "superagent";
import reloadIcon from "../../assets/image/Reload.svg";
import { BaseURL } from "../../BaseURL";
import API_URLS from "../../API_URLS/API_URLS";

const SafetyGear = () => {
  const [showForm, setForm] = useState(false);
  const [formValues, setFormValues] = useState({
    First_Name: "",
    Last_Name: "",
    Email: "",
    Phone_Number: "",
    Message: "",
  });

  const [captchaNum1, setCaptchaNum1] = useState(0);
  const [captchaNum2, setCaptchaNum2] = useState(0);
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaNum1(num1);
    setCaptchaNum2(num2);
    setCaptchaAnswer("");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleCaptchaChange = (event) => {
    setCaptchaAnswer(event.target.value);
  };
  const handleNumChangeM = (event) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    const limit1 = 10;
    setFormValues({
      ...formValues,
      Phone_Number: numericValue.slice(0, limit1),
    });
  };

  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const handleCatalog = (event) => {
    event.preventDefault();
    if (
      [
        formValues.First_Name,
        formValues.Last_Name,
        formValues.Email,
        formValues.Phone_Number,
        formValues.Message,
      ].some((field) => field?.trim() !== "")
    ) {
      // 2. Captcha check
      if (parseInt(captchaAnswer, 10) !== captchaNum1 + captchaNum2) {
        alert("Captcha verification failed. Please try again.");
        generateCaptcha();
        return;
      }
      setLoading(true); // start loader

      formValues.windowTitle = document.title;
      request
        // .post(`${BaseURL}/Mail/SafetyGear`)

        .post(`${API_URLS.SAFETY_GEAR}`)
        .send(formValues)
        .set("Accept", "application/json")
        .then((response) => {
          console.log(response.body.message);

          setForm(false);
          setShowPopup(true);

          setFormValues({
            First_Name: "",
            Last_Name: "",
            Email: "",
            Phone_Number: "",
            Message: "",
          });

          generateCaptcha();
        })
        .catch((error) => {
          console.error("Error sending Email:", error);
        })
        .finally(() => {
          setLoading(false); // stop loader
        });
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleReloadCaptcha = () => {
    generateCaptcha();
  };

  return (
    <div>
      <Helmet>
        <title>
          Business Process Automation Software | PPE Detection | Video analytics
          for Pharma Companies
        </title>
        <meta
          name="description"
          content="Safepro provide business process automation software, video analytics, gowning procedure for pharma companies. We offer PPE detection, video analytics for manufacturing companies, safety gear violation detection, workplace safety solutions, Intrusion detection and mobile Phone_Number usage detection in India.
          "
        />
        <meta
          name="keyword"
          content="process automation, process automation system, process automation companies, India, robotic process automation, business process automation, business automation, business process automation software, process automation software, PPE detection, gowning procedure in pharma, video analytics for pharma companies, Intrusion detection, mobile Phone_Number usage detection, safety gear violation detection, workplace safety solutions, video analytics for manufacturing companies
          "
        />
        <link
          rel="canonical"
          href="https://www.safepro.tech/videoanalytics/ppedetection/pharma.html"
        />
      </Helmet>
      <Header />
      <EProductspage />
      <section>
        <div className="Time_Attendance">
          <div className="first_Section">
            <div className="Left">
              <img src={image} alt="Safety Gear" />
            </div>
            <div className="Left_Mobile">
              <img src={image} alt="Safety Gear" />
            </div>
            <div className="right">
              <h1>Safety Gear Violation</h1>
              <a href="/videoanalytics/ppedetection/pharma.html">
                Ensure your workers safety
              </a>
              <p>
                While maintaining safety standards in your premises is of utmost
                importance, ensuring that your employees are adhering to these
                standards you’ve set is absolutely important too. Tracking this
                manually is impossible especially in your large premises and
                multiple operational sites. Our PPE violation detection system
                is designed for users to choose the PPE kits that’s relevant for
                their use and enable to detect these violations 24/7 without a
                human interference.It is integrated with a dashboard to give you
                instant visual alerts to the authorised officer with log reports
                to warn your employees to adhere to the safety norms thereby
                ensuring safety of your employees and avoid millions of dollars
                in penalties for the employer.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="section_3">
        <div className="section_3_Body_Section">
          <div className="section_3_width">
            <div className="section_3_content">
              <h4 className="Text">
                Personal protection equipments being mandatory, it’s impossible
                to keep tracking everyone in the premises adhering to it.
                Companies face damages with legal actions and monetary
                compensations for accidents without these safety gears.
                Opticsense edge video analytics handles this problem for you
                with ease. We enable your CCTV cameras in your premises to track
                your employees violating this, alerting the concerned and also
                create log file for your records.
              </h4>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <>
          <div className="Overlay" />
          <div className="Popup">
            <img
              src={icon4}
              alt="Close"
              className="CloseButton"
              onClick={() => setShowPopup(false)}
            />
            <img src={icon1} alt="Popup" />
            <span>
              <h1>Thank You</h1>

              <h3>
                <p>The form was submitted successfully</p>
                <p>You will receive a catalog on your email</p>
              </h3>
            </span>
          </div>
        </>
      )}
      {showForm && (
        <>
          <div className="uc_model">
            <div className="uc_content">
              <div className="uc_header">
                <p className="uc_heading_one">Please fill this form</p>
                <span>
                  <img
                    alt=""
                    srcSet={icon4}
                    height="30px"
                    onClick={() => {
                      setForm(false);
                    }}
                  />
                </span>
                <p className="uc_heading_two">
                  We will share you the product catalog through your email.
                </p>
              </div>
              <div className="uc_body">
                <form onSubmit={handleCatalog}>
                  <div className="uc-form-group" style={{ display: "flex" }}>
                    <div
                      className="Field"
                      style={{ width: "45%", paddingRight: "120px" }}
                    >
                      <div className="fcf-input-group_half">
                        <input
                          type="text"
                          id="First_Name"
                          value={formValues.First_Name}
                          name="First_Name"
                          className="uc-form-control"
                          placeholder="First Name"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="Field" style={{ width: "45%" }}>
                      <div className="fcf-input-group_half">
                        <input
                          type="text"
                          id="Last_Name"
                          value={formValues.Last_Name}
                          name="Last_Name"
                          className="uc-form-control"
                          placeholder="Last Name"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="uc-form-group" style={{ display: "flex" }}>
                    <div
                      className="Field"
                      style={{ width: "45%", paddingRight: "120px" }}
                    >
                      <div className="fcf-input-group_half">
                        <input
                          type="email"
                          id="Email"
                          value={formValues.Email}
                          name="Email"
                          className="uc-form-control"
                          placeholder="Email"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="Field" style={{ width: "45%" }}>
                      <div className="fcf-input-group_half">
                        <input
                          type="text"
                          id="Phone_Number"
                          maxLength="10"
                          value={formValues.Phone_Number}
                          name="Phone_Number"
                          className="uc-form-control"
                          placeholder="Phone number"
                          required
                          onChange={(e) => {
                            handleChange(e);
                            handleNumChangeM(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="uc-form-group">
                    <div className="">
                      <textarea
                        id="Message"
                        value={formValues.Message}
                        name="Message"
                        className="uc-form-control"
                        rows="6"
                        maxLength="3000"
                        placeholder="Write your message"
                        required
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>

                  <div className="Captcha_Products">
                    <div className="Captcha_Block">
                      <div className="numbers">
                        {captchaNum1} <label>+</label> {captchaNum2}{" "}
                        <label>=</label>
                      </div>
                      <input
                        className="Input_Field_1"
                        type="number"
                        value={captchaAnswer}
                        onChange={handleCaptchaChange}
                        aria-label="Enter the result of the captcha"
                      />
                      <img
                        className="Re"
                        src={reloadIcon}
                        onClick={handleReloadCaptcha}
                        alt="Reload"
                      />
                    </div>
                  </div>

                  <div className="uc-submit-button">
                    <button type="submit" disabled={loading}>
                      {loading ? (
                        <span>Submitting...</span>
                      ) : (
                        <>
                          <span>Submit</span>
                          <img alt="" srcSet={icon5} height="20px" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="Catalog_Container">
        <div
          className="Body_Content_Forth_Inner_Buttons"
          style={{ paddingBottom: "60px" }}
        >
          <button
            className="Body_Content_Forth_Button_One1"
            onClick={() => {
              setForm(true);
            }}
          >
            <strong>Product catalog</strong> &nbsp;
            <img alt="" srcSet={icon3} />
          </button>
        </div>
      </div>
      <Formpage />
      <Footer />
    </div>
  );
};

export default SafetyGear;
